<template>
    <div v-if="errors && errors.length" class="invalid-feedback d-block">
        <div v-for="error in errors" :key="error">{{ error }}</div>
    </div>
</template>

<script>
export default {
    name: 'FieldErrors',
    props: {
        errors: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
